import React from "react";
import icon1 from "../../assets/images/home/our-features/fun-icon1.png";
import icon2 from "../../assets/images/home/our-features/fun-icon2.png";
import icon3 from "../../assets/images/home/our-features/fun-icon3.png";
import icon4 from "../../assets/images/home/our-features/fun-icon4.png";

const OurFeatures = () => {
  return (
    <section className="funfacts-area bg-image pt-70">
      <div className="container">
        <div className="row">
          <div className="col-lg-3 col-sm-3 col-6">
            <div className="single-funfacts-item">
              <div className="icon">
                <img src={icon1} alt="fun" />
              </div>
              <h3>13年</h3>
              <p>专业eHR经验</p>
            </div>
          </div>

          <div className="col-lg-3 col-sm-3 col-6">
            <div className="single-funfacts-item">
              <div className="icon">
                <img src={icon2} alt="fun" />
              </div>
              <h3>150+</h3>
              <p>典型客户案例</p>
            </div>
          </div>

          <div className="col-lg-3 col-sm-3 col-6">
            <div className="single-funfacts-item">
              <div className="icon">
                <img src={icon3} alt="fun" />
              </div>
              <h3>7×24</h3>
              <p>专属客服支撑</p>
            </div>
          </div>

          <div className="col-lg-3 col-sm-3 col-6">
            <div className="single-funfacts-item">
              <div className="icon">
                <img src={icon4} alt="fun" />
              </div>
              <h3>360°</h3>
              <p>数据安全保障</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurFeatures;
